export default __webpack_public_path__ + "static/media/founder.918d7e56.jpg";